<template>
    <footer class="footer" v-bind:class="{'divider': this.showDivider}">Version {{ version }}. Copyright &copy; CPD Made Easy {{year}}</footer>
</template>

<script>

    export default {
        name: "Footer",
        props: {
            showDivider: {
                type: Boolean,
                required: false,
                default: true,
            }
        },
        data: function() {
            return {
                yearOrigin: 2009,
                yearNow: new Date().getUTCFullYear(),
                version: process.env.VUE_APP_VERSION
            }
        },
        computed: {
            year: function() {
                if (this.yearOrigin !== this.yearNow) {
                    return this.yearOrigin + ' - ' + this.yearNow;
                } else {
                    return this.yearNow;
                }
            }
        }
    }
</script>

<style scoped>
    .footer {
        margin-top: 40px;
        margin-bottom: 50px;
        padding-top: 5px;
        text-align: center;
        font-size: 12px;
    }

    .footer.divider {
        border-top: lightgrey 1px solid;
    }
</style>
